let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lRcNv")).then(() => parcelRequire('kS8nn'));